if ( $(".whirlgig_contents").length ) {

// Ref: https://greensock.com/docs/TimelineLite
    jQuery('.whirlgig_contents').children().hide();
// Animations
// Middle layer - First layer of buttons
    var animate_middle = new TimelineLite({paused: true});

    animate_middle
        .from("#middle-layer", 0.5, {
            transformOrigin: "50% 50%",
            scale: "0"
        }, 0, 0)

        .from("#middle-layer #button-group", 0.75, {
            transformOrigin: "50% 50%",
            rotation: "-=135"
        }, 0, 0)

        .from("#middle-layer #button-group", 0.5, {
            opacity: "0"
        }, 0, 0)
    ;

// Outside layer - Outside layer menu background
    var animate_outside = new TimelineLite({paused: true});

    animate_outside
        .from("#outside-layer", 0.5, {
            transformOrigin: "50% 50%",
            scale: "0"
        }, 0, 0)
    ;

// Applications buttons
    var animate_applications = new TimelineLite({paused: true});

    animate_applications
        .staggerFrom(".applications g", 0.5, {
            transformOrigin: "50% 50%",
            opacity: "0",
            scale: "0"
        }, 0.125, 0.25)
    ;

    var animate_payments = new TimelineLite({paused: true});

    animate_payments
        .staggerFrom(".payments g", 0.5, {
            transformOrigin: "50% 50%",
            opacity: "0",
            scale: "0"
        }, 0.125, 0.25)
    ;

    /*
    var animate_contacts = new TimelineLite({paused: true});

    animate_contacts
        .staggerFrom(".contacts g", 0.5, {
            transformOrigin:"50% 50%",
            opacity: "0",
            scale: "0"
        }, 0.125, 0.25)
    ;
    */
    var animate_automations = new TimelineLite({paused: true});

    animate_automations
        .staggerFrom(".automations g", 0.5, {
            transformOrigin: "50% 50%",
            opacity: "0",
            scale: "0"
        }, 0.125, 0.25)
    ;

    var animate_messagings = new TimelineLite({paused: true});

    animate_messagings
        .staggerFrom(".messagings g", 0.5, {
            transformOrigin: "50% 50%",
            opacity: "0",
            scale: "0"
        }, 0.125, 0.25)
    ;


// Interaction

// Variables
    var menuOpen = false;
    var outsideCircleOpen = false;
    var applicationsOpen = false;
    var paymentsOpen = false;
//var contactsOpen = false;
    var automationsOpen = false;
    var messagingsOpen = false;


    jQuery.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + jQuery(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + jQuery(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

// Main (Center) Button

    jQuery(window).on('resize scroll', function () {
        if (jQuery('#main-layer').isInViewport()) {
            if (menuOpen == false) {
                jQuery('#main-layer').addClass('is-active');
                animate_middle.play();
                menuOpen = true;
            }
        }
    });

    jQuery('#main-layer').click(function () {

        if (menuOpen == false) {

            jQuery('#main-layer').addClass('is-active');
            animate_middle.play();
            menuOpen = true;

        } else {

            jQuery('#middle-layer [class*="-button"]').removeClass('is-active');
            jQuery('#outside-layer [class*="-button"]').removeClass('is-active');

            setTimeout(function () {
                jQuery('#main-layer').removeClass('is-active');
            }, 750);

            animate_middle.reverse();
            animate_outside.reverse();

            animate_applications.reverse();
            animate_payments.reverse();
            //animate_contacts.reverse();
            animate_automations.reverse();
            animate_messagings.reverse();

            // reset all variables
            menuOpen = false;
            outsideCircleOpen = false;
            applicationsOpen = false;
            paymentsOpen = false;
            //ctsOpen = false;
            automationsOpen = false;
            messagingsOpen = false;

        }

    });

// applications Button
    jQuery('.applications-button').click(function () {

        if (applicationsOpen == false) {

            if (outsideCircleOpen == false) {
                animate_outside.play();
            }

            animate_applications.play();

            outsideCircleOpen = true;
            applicationsOpen = true;

            animate_payments.reverse();
            //animate_contacts.reverse();
            animate_automations.reverse();
            animate_messagings.reverse();

            jQuery(this).addClass('is-active');

        } else {
            applicationsOpen = false;
            outsideCircleOpen = false;
            animate_outside.reverse();
            animate_applications.reverse();
        }

        paymentsOpen = false;
        //contactsOpen = false;
        automationsOpen = false;
        messagingsOpen = false;

    });

// payments Button
    jQuery('.payments-button').click(function () {

        if (paymentsOpen == false) {

            if (outsideCircleOpen == false) {
                animate_outside.play();
            }

            animate_payments.play();

            outsideCircleOpen = true;
            paymentsOpen = true;

            animate_applications.reverse();
            //animate_contacts.reverse();
            animate_automations.reverse();
            animate_messagings.reverse();

            jQuery(this).addClass('is-active');

        } else {
            paymentsOpen = false;
            outsideCircleOpen = false;
            animate_outside.reverse();
            animate_payments.reverse();
        }

        applicationsOpen = false;
        //contactsOpen = false;
        automationsOpen = false;
        messagingsOpen = false;

    });


// contacts Button
    /*
    jQuery('.contacts-button').click(function() {

        if(contactsOpen == false) {

            if(outsideCircleOpen == false) {
                animate_outside.play();
            }

            animate_contacts.play();

            outsideCircleOpen = true;
            contactsOpen = true;

            animate_applications.reverse();
            animate_payments.reverse();
            animate_automations.reverse();
            animate_messagings.reverse();

            jQuery(this).addClass('is-active');

        } else {
            contactsOpen = false;
            outsideCircleOpen = false;
            animate_outside.reverse();
            animate_contacts.reverse();
        }

        applicationsOpen = false;
        paymentsOpen = false;
        automationsOpen = false;
        messagingsOpen = false;

    });
    */
// automations Button
    jQuery('.automations-button').click(function () {

        if (automationsOpen == false) {

            if (outsideCircleOpen == false) {
                animate_outside.play();
            }

            animate_automations.play();

            outsideCircleOpen = true;
            automationsOpen = true;

            animate_applications.reverse();
            animate_payments.reverse();
            //animate_contacts.reverse();
            animate_messagings.reverse();

            jQuery(this).addClass('is-active');

        } else {
            automationsOpen = false;
            outsideCircleOpen = false;
            animate_outside.reverse();
            animate_automations.reverse();
        }

        applicationsOpen = false;
        paymentsOpen = false;
        //contactsOpen = false;
        messagingsOpen = false;

    });

// messagings Button
    jQuery('.messagings-button').click(function () {

        if (messagingsOpen == false) {

            if (outsideCircleOpen == false) {
                animate_outside.play();
            }

            animate_messagings.play();

            outsideCircleOpen = true;
            messagingsOpen = true;

            animate_applications.reverse();
            animate_payments.reverse();
            //animate_contacts.reverse();
            animate_automations.reverse();

            jQuery(this).addClass('is-active');

        } else {
            messagingsOpen = false;
            outsideCircleOpen = false;
            animate_outside.reverse();
            animate_messagings.reverse();
        }

        applicationsOpen = false;
        paymentsOpen = false;
        //contactsOpen = false;
        automationsOpen = false;

    });

// Middle Layer Active States

    jQuery('#middle-layer [class*="-button"]').click(function () {
        jQuery('#middle-layer [class*="-button"]').removeClass('is-active');
        jQuery('#outside-layer [class*="-button"]').removeClass('is-active');
        jQuery(this).addClass('is-active');

    });


//Outside Layer Active States
    jQuery('#outside-layer [class*="-button"]').click(function () {
        jQuery('#outside-layer [class*="-button"]').removeClass('is-active');
        var luokka = jQuery(this).attr('class');

        function loadContent(luokka) {
            var res = luokka.replace("button", "content");
            jQuery('.whirlgig_contents').children().fadeOut(300);
            jQuery('.' + res).delay(300).fadeIn(300);
        }

        loadContent(luokka);
        jQuery(this).addClass('is-active');
    });
}